import React from 'react';
import { Box } from '@mui/material';
import { APP_VERSION, BUILD_DATE, BUILD_NUMBER, BUILD_GIT_SHA } from '../../buildInfo';

function formatBuildDate(value: string) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}

export function Version() {
  const gitSha = String(BUILD_GIT_SHA || '');
  const gitSuffix = gitSha ? ` • ${gitSha.slice(0, 7)}` : '';
  return (
    <Box
      sx={{
        fontSize: '12px',
        color: '#9ca3af',
        textAlign: 'right'
      }}
      title={`Version ${APP_VERSION} • Build ${BUILD_NUMBER}${gitSuffix} • Built ${formatBuildDate(BUILD_DATE)}`}
    >
      {`v${APP_VERSION} • build ${BUILD_NUMBER}${gitSuffix}`}
    </Box>
  );
}

export default Version;
